import useSearches from './functions/useSearches';
import useLoadPassengers from './functions/useLoadPassengers';
import useInactivatePassenger from './functions/useInactivatePassenger';
import useActivatePassenger from './functions/useActivatePassenger';
import useModals from './functions/useModals';

export default function usePassengers() {
  const {
    passengerBeingReactivated,
    pasengerBeingInactivated,
    passengerRoutingBeingShow,
    reactivateModalShow,
    inactivateModalShow,
    passengerRoutingModalShow,
    handleOpenReactivateModal,
    handleOpenInactivateModal,
    handleOpenPassengerRoutingModal,
    isReactivateDateSet,
    reactivateDate,
    handleReactivateDateChange,
    setIsReactivateDateSet,
    passengerInfoBeingShow,
    infoModalShow,
    handleOpenPassengerInfoModal,
    setInactivateModalShow,
    setReactivateDate,
    setReactivateModalShow,
    setInfoModalShow,
    setPassengerRoutingModalShow,
    reactivatePassengerCode,
    inactivatePassengerCode,
  } = useModals();

  const {
    isLoading,
    workplaces,
    passengers,
    doesWorkplacesListExists,
    doesPassengersListExists,
    apiWorkplaceFetched,
    apiPassengersFetched,
    selectedWorkplace,
    handleWorkplaceChange,
    handleTryGetWorkplacesAgain,
    handleTryGetpassengersAgain,
    getPassengers,
    goingLineOptions,
    backLineOptions,
    statusOptions,
  } = useLoadPassengers();

  const {
    filteredPassengers,
    handleChangeSearchNameTerm,
    handleChangeSearchCpfTerm,
    handleChangeSearchConsultTerm,
    handleChangeSelectedGoingLine,
    handleChangeSelectedBackLine,
    handleChangeSelectedStatus,
    searchCpfTerm,
    searchNameTerm,
    searchConsultTerm,
    selectedGoingLine,
    selectedBackLine,
    selectedStatus,
  } = useSearches({ passengers });

  const {
    isInactivating,
    handleInactivatePassenger,
  } = useInactivatePassenger({ getPassengers, workplaceCode: selectedWorkplace.value, isReactivateDateSet, reactivateDate, inactivatePassengerCode });

  const {
    isReactivating,
    handleActivatePassenger,
  } = useActivatePassenger({ getPassengers, workplaceCode: selectedWorkplace.value, isReactivateDateSet, reactivateDate, reactivatePassengerCode });

  return {
    isLoading,
    handleChangeSearchCpfTerm,
    searchCpfTerm,
    workplaces,
    passengers,
    filteredPassengers,
    doesWorkplacesListExists,
    doesPassengersListExists,
    apiWorkplaceFetched,
    apiPassengersFetched,
    selectedWorkplace,
    searchNameTerm,
    searchConsultTerm,
    selectedGoingLine,
    selectedBackLine,
    selectedStatus,
    passengerBeingReactivated,
    pasengerBeingInactivated,
    passengerRoutingBeingShow,
    reactivateModalShow,
    inactivateModalShow,
    passengerRoutingModalShow,
    handleOpenReactivateModal,
    handleOpenInactivateModal,
    handleOpenPassengerRoutingModal,
    handleWorkplaceChange,
    handleChangeSearchNameTerm,
    handleChangeSearchConsultTerm,
    handleChangeSelectedGoingLine,
    handleChangeSelectedBackLine,
    handleChangeSelectedStatus,
    handleTryGetWorkplacesAgain,
    handleTryGetpassengersAgain,
    isInactivating,
    handleInactivatePassenger,
    isReactivateDateSet,
    reactivateDate,
    handleReactivateDateChange,
    isReactivating,
    handleActivatePassenger,
    setIsReactivateDateSet,
    passengerInfoBeingShow,
    infoModalShow,
    handleOpenPassengerInfoModal,
    goingLineOptions,
    backLineOptions,
    statusOptions,
    setInactivateModalShow,
    setReactivateDate,
    setReactivateModalShow,
    setInfoModalShow,
    setPassengerRoutingModalShow,
  };
}
